module.exports = __webpack_public_path__ + "img/Kasargod-Medical-College-(Kitco).f28becf8.jpg";